import { useAppMutation } from 'services/reactQuery/useAppMutation';
import StaffHTTPService from 'services/HTTPService/staff/StaffHTTPService';
import { commonTexts } from 'consts/text';
import { useSimpleNotification } from 'hooks/useSimpleNotification/useSimpleNotification';
import { AppButton, AppTitle } from 'components/atoms';

export const UtilsPage = () => {
    const { displaySuccess, displayError } = useSimpleNotification();

    const { mutate: recalculateAllSettlements, isLoading: isRecalculateAllSettlementsLoading } =
        useAppMutation(StaffHTTPService.utils.recalculateAllSettlements, {
            key: ['RECALCULATE_ALL_SETTLEMENTS'],
            onSuccess: () => displaySuccess(commonTexts.successMessages.actionSuccess),
            onError: () => displayError(commonTexts.errorMessages.actionExecution),
        });

    return (
        <div>
            <AppTitle>Utils Page</AppTitle>
            <AppButton
                loading={isRecalculateAllSettlementsLoading}
                onClick={() => recalculateAllSettlements()}
            >
                Recalculate all settlements
            </AppButton>
        </div>
    );
};
